function getSavedProducts() {
  return JSON.parse(localStorage.getItem("inquireList")) || [];
}

function getProductsCount() {
  const products = getSavedProducts();
  return products.reduce((total, item) => total + (parseInt(item.quantity) || 1), 0);
}

function setSavedProducts(arr) {
  localStorage.setItem("inquireList", JSON.stringify(arr));
}

const inquireBubble = document.querySelector("[js-inquire-bubble]");
if (inquireBubble) {
  inquireBubble.textContent = getProductsCount();
  getProductsCount() > 0 ? inquireBubble.classList.remove('hidden') : inquireBubble.classList.add('hidden');
}

function appendProductToStorage(product) {
  const current = getSavedProducts();
  const existingIndex = current.findIndex(p => p.id === product.id || p.sku === product.sku);

  if (existingIndex !== -1) {
    current[existingIndex].quantity = (parseInt(current[existingIndex].quantity) || 1) + product.quantity;
  } else {
    current.push({ ...product });
  }

  setSavedProducts(current);
}

function addProductToInquiry(product) {
  if (!product || !product.id) return;

  const productData = {
    id: product.id,
    title: product.title || '',
    image: product.image || '',
    sku: product.sku || '',
    quantity: parseInt(product.quantity) || 1,
    url: product.url || window.location.href,
  };

  appendProductToStorage(productData);

  if (inquireBubble) {
    inquireBubble.textContent = getProductsCount();
    getProductsCount() > 0 ? inquireBubble.classList.remove('hidden') : inquireBubble.classList.add('hidden');
  }

  const car_notification = document.querySelector('.cart-notification');
  if (car_notification) {
    car_notification.classList.add('show');
    setTimeout(() => {
      car_notification.classList.remove('show');
    }, 8000);
  }
}

document.addEventListener('addToInquiry', function(event) {
  const product = event.detail;
  if (product) addProductToInquiry(product);
});

document.addEventListener('click', function(e) {
  const closeBtn = e.target.closest('.cart-notification button, .cart-notification .close, .cart-notification [aria-label="Close"]');
  if (!closeBtn) return;
  const toast = closeBtn.closest('.cart-notification');
  if (toast) toast.classList.remove('show');
});

const mainProduct = document.querySelector("[js-main-product]");

if (mainProduct) {
  const inquiryBtn = mainProduct.querySelector('#inquiry-button');
  const popup = mainProduct.querySelector('.inquire-form-popup');
  const car_notification = document.querySelector('.cart-notification');
  const closeBtn = mainProduct.querySelector('.popup-close');
  const overlay = mainProduct.querySelector('.inquire-form-popup__overlay');
  const qtyField = mainProduct.querySelector('[js-quantity-field]');

  if (inquiryBtn && car_notification) {
    inquiryBtn.addEventListener('click', function () {
      addProductToInquiry({
        id: mainProduct.dataset.id,
        title: mainProduct.dataset.title,
        image: mainProduct.dataset.image,
        sku: mainProduct.dataset.sku,
        quantity: parseInt(qtyField?.value) || 1,
        url: mainProduct.dataset.url,
      });
    });
  }

  if (closeBtn && popup) {
    closeBtn.addEventListener('click', function () {
      popup.style.display = 'none';
    });
  }

  if (overlay && popup) {
    overlay.addEventListener('click', function () {
      popup.style.display = 'none';
    });
  }
}

const inquireEl = document.querySelector('[js-inquire-list]');

if (inquireEl) {
  const inquireMain = document.querySelector("[js-inquire-main]");
  const emptyContentEl = document.querySelector("[js-empty-content]");

  function renderInquireList() {
    const items = getSavedProducts();

    if (!items.length) {
      inquireEl.innerHTML = '<p class="empty-msg">No products added yet.</p>';
      if (inquireMain) inquireMain.classList.add("hidden");
      if (emptyContentEl) emptyContentEl.classList.remove("hidden");
      return;
    }

    inquireEl.innerHTML = items.map((p, i) => `
      <div class="table__item" data-index="${i}">
        <div class="product__meta">
          <a href="${p.url}" class="product__img">
            <img src="${p.image}" alt="${p.title}" />
          </a>
          <a href="${p.url}" class="product__link">
            <h3 class="product__title table__value">${p.title}</h3>
          </a>
        </div>

        <div class="product__article">
          <span class="article__number table__value">${p.sku}</span>
        </div>

        <div class="product__qty">
          <input type="number" value="${p.quantity}" min="1" js-inquire-qty-field data-id="${p.id}">
          <button class="cross__icon" aria-label="Remove" js-remove-inquire-btn id="${p.id}">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6.4 19L5 17.6L10.6 12L5 6.4L6.4 5L12 10.6L17.6 5 L19 6.4L13.4 12L19 17.6L17.6 19L12 13.4L6.4 19Z" fill="#F00505"/>
            </svg>
          </button>
        </div>
      </div>`).join('');

    if (emptyContentEl) emptyContentEl.classList.add("hidden");
    if (inquireMain) inquireMain.classList.remove("hidden");
  }

  renderInquireList();

  document.addEventListener('click', ({ target }) => {
    if (!target.hasAttribute("js-remove-inquire-btn")) return;

    const id = target.getAttribute('id');
    if (!id) return;

    const items = getSavedProducts();
    const updatedItems = items.filter(p => String(p.id) !== String(id));

    setSavedProducts(updatedItems);
    renderInquireList();
    renderSelectedProductMeta();
    if (inquireBubble) {
      inquireBubble.textContent = getProductsCount();
      getProductsCount() > 0 ? inquireBubble.classList.remove('hidden') : inquireBubble.classList.add('hidden');
    }
  });

  document.addEventListener('change', ({ target }) => {
    if (!target.hasAttribute("js-inquire-qty-field")) return;

    const id = target.getAttribute('data-id');
    const newQty = parseInt(target.value);

    const items = getSavedProducts();
    const index = items.findIndex(p => String(p.id) === String(id));

    if (index !== -1 && newQty > 0) {
      items[index].quantity = newQty;
      setSavedProducts(items);
      if (inquireBubble) {
        inquireBubble.textContent = getProductsCount();
        getProductsCount() > 0 ? inquireBubble.classList.remove('hidden') : inquireBubble.classList.add('hidden');
      }
      renderSelectedProductMeta();
    }
  });
}

function renderSelectedProductMeta() {
  const selectedProductField = document.querySelector("[js-selected-products-field]");

  if (selectedProductField) {
    const items = getSavedProducts();
    const productString = items.map(p => `${p.title} - ${p.sku} (Qty: ${p.quantity})`).join(', ');
    selectedProductField.value = productString;
  }
}

renderSelectedProductMeta();
